const normalizeVideoUrl = (src) => {
    if (typeof src !== 'string' || !src.trim()) return src;

    try {
        const url = new URL(src);
        const host = url.hostname.replace(/^www\./, '');

        if (host === 'youtu.be') {
            const videoId = url.pathname.replace(/^\/+/, '').split('/')[0];
            if (videoId) {
                return `https://www.youtube.com/watch?v=${videoId}`;
            }
        }

        if (host === 'player.vimeo.com' && url.pathname.includes('/video/')) {
            const segments = url.pathname.split('/').filter(Boolean);
            const videoIndex = segments.indexOf('video');
            const videoId = videoIndex >= 0 ? segments[videoIndex + 1] : '';

            if (videoId) {
                return `https://vimeo.com/${videoId}`;
            }
        }
    } catch (error) {
        return src;
    }

    return src;
};

$("a.video, button.video").each(function () {
    const video = $(this);
    const thisVideoSrc = video.data('mfp-src');
    const normalizedVideoSrc = normalizeVideoUrl(thisVideoSrc);

    if (normalizedVideoSrc !== thisVideoSrc) {
        video.attr('data-mfp-src', normalizedVideoSrc);
    }

    video.magnificPopup({
        type: "iframe",
        removalDelay: 160,
        preloader: !1,
        fixedContentPos: !1
    });
});
